module.exports = __webpack_public_path__ + "static/img/10.6f60b29.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/4/zh/10.png
// module id = vzQN
// module chunks = 0